import logger from '../logger'
import loadScript from './load-script'
import onload from './onload'

/**
 * Asynchronously loads the eightlytics script, creating a local interim queue, that is sent once the script has loaded.
 *
 * @param {Window} window A reference to the main frame's window object.
 */
export function loadlytics(window, config) {
  if (isLegacyEightlyticsActive(window)) {
    window.eightlytics = null
  }
  window.eightlytics =
    window.eightlytics ||
    function() {
      window.eightlytics.queue = window.eightlytics.queue || window.eightlytics_queue || []
      window.eightlytics_queue = null
      window.eightlytics.queue.push(arguments)
    }

  window.eightlytics.queue = window.eightlytics.queue || window.eightlytics_queue || []
  window.eightlytics_queue = null

  let shouldSendData =
    process.env.NODE_ENV === 'production' && !window.mconPreview && config.demoMode.isActive() === false

  if (shouldSendData === true) {
    const url = getUrl(config)
    if (url) {
      loadScript(window, url)
    } else {
      logger('8.LYTICS url not defined - disabled sending data.', { config })
      shouldSendData = false
    }
  }

  if (shouldSendData === false) {
    window.eightlytics = {
      client: {
        dispatchEvent: (event, enrichedConfig, callback) => {
          logger('8.LYTICS disabled for non-production and demo mode. Would have sent this:', {
            event,
            enrichedConfig,
          })
          if (callback) {
            return callback()
          }
        },
      },
    }
    onload()
  }
}

function isLegacyEightlyticsActive(window) {
  return !!window.eightlytics_queue
}

function getUrl(config) {
  if (
    config &&
    config.eightlytics &&
    config.eightlytics.url &&
    config.eightlytics.url.match(/https:\/\/eltx.*.8select.io\/eightlytics\/client.*.js/) !== null
  ) {
    return config.eightlytics.url
  }

  return process.env.EIGHTLYTICS_URL ? process.env.EIGHTLYTICS_URL.replace('wgt', 'eltx') : process.env.EIGHTLYTICS_URL
}

export default loadlytics
